import React from 'react';
import { HeaderLeft, HeaderRight, Header } from '@/components/atoms/Section/Section.style';
import { Title } from '@/components/atoms/Title';
import { Table } from '../../components/atoms/Table/Table';
import { Container, HeaderContainer } from './RestaurantUsersList.style';
import useRestaurantUsersListVM from './RestaurantUsersList.viewmodel';
import { SvyButton } from '../../components/savory/SvyButton';
import { FormattedMessage } from 'react-intl';
import CreateRestaurantUserForm from './components/CreateRestaurantUserForm/CreateRestaurantUserForm';
import RouterNavigationTabs from '@/components/organisms/RouterNavigationTabs';
import { useRestaurantTabRoutes } from '../Restaurant/hooks/useRestaurantTabRoutes';

const RestaurantUsersList = () => {
    const {
        rows,
        columns,
        fetchData,
        isNewUserModalOpen,
        openNewUserModal,
        closeNewUserModal,
        canCreateUser,
        data,
        isLoading,
        handleRowClick,
    } = useRestaurantUsersListVM();
    const tabRoutes = useRestaurantTabRoutes();

    return (
        <RouterNavigationTabs routes={tabRoutes}>
            <Container>
                <CreateRestaurantUserForm isOpen={isNewUserModalOpen} onHide={closeNewUserModal} />
                <HeaderContainer>
                    <Header>
                        <HeaderLeft>
                            <Title text="route.restaurantUsers" />
                        </HeaderLeft>
                        <HeaderRight>
                            {canCreateUser && (
                                <SvyButton size="s" onClick={openNewUserModal}>
                                    <FormattedMessage id="brandUsers.newUser" />
                                </SvyButton>
                            )}
                        </HeaderRight>
                    </Header>
                    <div>
                        <Table
                            rows={rows}
                            emptyMessageId="table.noRowsAfterFilter"
                            columns={columns}
                            isSearchable
                            fetchData={fetchData}
                            fetchDataTotalCount={data?.length}
                            isLoading={isLoading}
                            onRowClick={handleRowClick}
                        />
                    </div>
                </HeaderContainer>
            </Container>
        </RouterNavigationTabs>
    );
};
export default RestaurantUsersList;
